export function cleanSubscriptionName(name: string): string {
    const regex = /([a-zA-Z])+/g;
    const subName = name.match(regex);
    return (subName ? subName[0] : name).toLowerCase();
}
